import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

const AdminDashboardExamReport = ({title, color1, color2, color3, text1, text2, text3, value1, value2, value3}) => {
  return (
    <Box 
      py="30px" 
      px={5} 
      h={['100%','100%','400px']} 
      bgColor="#FFFFFF" 
      borderRadius="14px" 
      border="1px solid #E3EBEE"
      overflow="auto"
    >
      <Text fontSize="14px" fontWeight="500" letterSpacing="-0.154px" color="#D73439" mb={5}>
        {title ? title : "Exam Report"}
      </Text>
        <Flex w="100%" direction={['column', 'column','column','column', 'row']} py={4} justifyContent={'center'} alignItems={'center'} gap={6}>
            <Box 
                position="relative" 
                width={"100%"} 
                maxWidth="300px" 
                height="250px" 
                m="0 auto"
                borderRight={["none", "none", "none","none", '1px solid #E4E5E7']}
            >
                {/* First Circle */}
                <Box
                position="absolute"
                top={["60px","65px", "70px", "40px"]}
                left={["0px", "0px","0px", "0px"]}
                width={["120px", "150px", "150px"]}
                height={["120px", "150px", "150px"]}
                borderRadius="full"
                bg={color1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                boxShadow="lg"
                >
                <Text fontWeight="bold" color="white" fontSize={["sm", "md", "lg"]}>{value1}</Text>
                </Box>

                {/* Second Circle */}
                <Box
                position="absolute"
                top={["80px", "90px", "40px", "60px"]}
                left={["100px","130px", "180px", "120px"]}
                width={["80px", "100px", "110px"]}
                height={["80px", "100px", "110px"]}
                borderRadius="full"
                bg={color2}
                display="flex"
                alignItems="center"
                justifyContent="center"
                boxShadow="lg"
                >
                <Text fontWeight="bold" color="white" fontSize={["sm", "md", "lg"]}>{value2}</Text>
                </Box>

                {/* Third Circle */}
                <Box
                position="absolute"
                top={["145px", "170px", "180px", "150px"]}
                left={["80px","100px", "140px", "100px"]}
                width={["60px", "80px", "80px"]}
                height={["60px", "80px", "80px"]}
                borderRadius="full"
                bg={color3}
                display="flex"
                alignItems="center"
                justifyContent="center"
                boxShadow="lg"
                >
                <Text fontWeight="bold" color="white" fontSize={["sm", "md", "lg"]}>{value3}</Text>
                </Box>
            </Box>
            <Flex direction="column" justifyContent="center" width={"100%"} >
                <Flex alignItems={'center'} gap={2} width={'100%'}>
                    <Box bg={ color1 ? color1 :"#D11A2A"} h={2} w={4} borderRadius="3px" maxWidth={['4%', '4%','4%', '8%']}></Box>
                    <Text fontSize="sm" color="#4D4D4D" maxWidth={['96%', '96%','96%', '92%']}>{text1 ? text1 : "Accepted"}</Text>
                </Flex>
                <Flex alignItems={'center'} gap={2} width={'100%'}>
                    <Box bg={ color2 ? color2 :"#D7343930"} h={2} w={4} borderRadius="3px" maxWidth={['4%', '4%','4%', '8%']}></Box>
                    <Text fontSize="sm" color="#4D4D4D" maxWidth={['96%', '96%','96%', '92%']}>{ text2 ? text2 : "Rejected"}</Text>
                </Flex>
                <Flex alignItems={'center'} gap={2} width={'100%'}>
                    <Box bg={ color3 ? color3 :"#D7343930"} h={2} w={4} borderRadius="3px" maxWidth={['4%', '4%','4%', '8%']}></Box>
                    <Text fontSize="sm" color="#4D4D4D" maxWidth={['96%', '96%','96%', '92%']}>{ text3 ? text3 : "Rejected"}</Text>
                </Flex>
            </Flex>
        </Flex>
    </Box>
  );
}

export default AdminDashboardExamReport;
